import React from 'react'
import $ from 'jquery'
const STYLES = {
			wrapper: {
				marginTop:'10px',
			},
			toolWrapper: {
				marginTop: '20px',
				position: 'relative'
			},
			toolCheckboxWrapper: {
				position: 'absolute',
				width: 'inherit',
				display: 'inline',
			},
			toolCheckbox: {
				':before': {
					overflow: 'hidden',				}
			},
			toolBlurb: {
				fontSize: '15px',
				lineHeight: '18px',
				marginLeft: '40px'
			},
			toolTip: {
				position: 'relative',
				display: 'none',
				maxWidth: '430px',
				margin: '5px auto',
			},
			tipIcon: {
				color: '#1189d6',
				cursor: 'pointer',
			},
			toolTipTxt: {
				backgroundColor: '#e1e7eb',
				fontSize: '12px',
				lineHeight: '1.8',
				textAlign: 'left',
				borderRadius: '6px',
				padding: '5px 7px',
				display: 'block',
			}
}

export default React.createClass({
	getInitialState () {
		return {};
	},

	handleTipClick () {
		$('#toolTip').slideToggle('fast')
	},

	render () {
		return (
			<div className="row" style={{...STYLES.wrapper}}>
				<div className="col-xs-12 col-sm-12 col-md-12">
					<div style={{...STYLES.toolWrapper}}>
							<div className="vx_checkbox" style={{...STYLES.toolCheckboxWrapper}}>
								<input type="checkbox" id="accountLegalCheckbox" />
								<label htmlFor="accountLegalCheckbox" style={{...STYLES.toolCheckbox}}/>
							</div>
							<p style={{...STYLES.toolBlurb}}>{this.props.label}
								<span onClick={this.handleTipClick} style={{...STYLES.tipIcon}} className="icon icon-small icon-tooltip-small" aria-hidden="true"></span>
							</p>
						</div>
				</div>
				<div id="toolTip" className="col-xs-12 col-sm-12 col-md-12" style={{...STYLES.toolTip}}>
					<span style={{...STYLES.toolTipTxt}}>{this.props.toolTipText}</span>
				</div>
			</div>
		);
	}
});



// WEBPACK FOOTER //
// ./guest/addressCheckbox.js